class HelpMeChoose extends HTMLElement {
    constructor() {
        super();
        var objj = this;
        var steps_handle = this.querySelectorAll('[JSHANDLESTEPS]');
        if(steps_handle.length > 0){
            steps_handle.forEach(function(step){
                step.addEventListener('click', (e) => objj.steps_handling(e))
            });
        }
        var year_select = this.querySelector('#year_select');
        if(year_select){
            year_select.addEventListener('change', (e) => objj.year_selection(e))
        }
        var price_select = this.querySelector('#dress_price_select');
        if(price_select){
            price_select.addEventListener('keyup', (e) => objj.price_selection(e))
        }
        this.addons_handling();
    }
    steps_handling(e){
        e.preventDefault();
        var target_href = e.target.getAttribute('href'), current_href = e.target.dataset.current;

        if(e.target.hasAttribute('NOTSURETEP')){
            this.querySelector('#dress_price_select').value = '$100';
        }

        if(e.target.hasAttribute('FINALSTEPHANDLE')){
            var selected_option_values=[], objj = this;
            selected_option_values.push(this.querySelector('#year_select').value, this.querySelector('#wear_again_select').value, this.querySelector('#dress_price_select').value);
            var price_format = selected_option_values[2].replace('$','');
            if(this.querySelectorAll('.product_itemMN').length > 0){
                this.querySelectorAll('.product_itemMN').forEach(function(product){
                    product.classList.add('hide');
                })
            }
            this.querySelectorAll('#hiddenMatchSelector option').forEach(function(option){
                var opt_value = option.value, 
                    opt_min_year = option.dataset.minYear, 
                    opt_max_year = option.dataset.maxYear, 
                    opt_min_price = option.dataset.minPrice.replace('$',''),
                    opt_max_price = option.dataset.maxPrice.replace('$',''),
                    opt_wear_again = option.dataset.wearAgain;

                if(parseInt(selected_option_values[0]) >= parseInt(opt_min_year) && selected_option_values[1] == opt_wear_again && parseInt(price_format) >= parseInt(opt_min_price) && parseInt(price_format) <= parseInt(opt_max_price)){
                    objj.querySelector(`.product_itemMN[handle="${opt_value}"]`).classList.remove('hide');
                }else if(parseInt(selected_option_values[0]) >= parseInt(opt_min_year) && selected_option_values[1] == opt_wear_again && parseInt(price_format) >= parseInt(opt_min_price) && parseInt(price_format) <= parseInt(opt_max_price)){
                    objj.querySelector(`.product_itemMN[handle="${opt_value}"]`).classList.remove('hide');
                }else if(parseInt(selected_option_values[0]) <= parseInt(opt_min_year) && selected_option_values[1] == opt_wear_again && opt_min_price == 'any'){
                    objj.querySelector(`.product_itemMN[handle="${opt_value}"]`).classList.remove('hide');
                }else if(selected_option_values[1] == opt_wear_again && opt_min_year == 'any' && opt_min_price == 'any'){
                    objj.querySelector(`.product_itemMN[handle="${opt_value}"]`).classList.remove('hide');
                }
            })
        }

        if(e.target.hasAttribute('RESTARTHANDLE')){
            fetch(window.location.href)
            .then(response => response.text())
            .then(data =>{
                const help_me_html = new DOMParser().parseFromString(data,'text/html').querySelector('help-me-choose');
                document.querySelector('help-me-choose').outerHTML = help_me_html.outerHTML;
            })
        }
        
        if(this.querySelector(target_href)){
            this.querySelector(target_href).classList.remove('hide');
            this.querySelector(target_href).classList.add('active');
            this.querySelector(current_href).classList.add('hide');
            this.querySelector(current_href).classList.remove('active');
        }
    }

    year_selection(e){
        if(e.target.value == 'select_year'){
            e.target.parentNode.querySelector('.target_button [data-option="next"]').setAttribute('disabled','')
        }else{
            e.target.parentNode.querySelector('.target_button [data-option="next"]').removeAttribute('disabled')
        }
    }

    price_selection(e){
        if(e.target.value && e.target.value !== '$'){
            var value = e.target.value.replace(/[^0-9]/g, '');
            if (value) {
                value = parseInt(value, 10);
                if(e.target.value.includes('$')){
                    e.target.value = e.target.value.replace('$','')
                }
                if(e.target.value == 0 || e.target.value == ''){
                    e.target.parentNode.querySelector('.target_button [data-option="next"]').setAttribute('disabled','')
                }else{
                    e.target.parentNode.querySelector('.target_button [data-option="next"]').removeAttribute('disabled')
                }
                e.target.value = '$' + e.target.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            }else{
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }
        }else{
            if(e.target.value == 0 || e.target.value == ''){
                e.target.parentNode.querySelector('.target_button [data-option="next"]').setAttribute('disabled','')
            }else{
                e.target.parentNode.querySelector('.target_button [data-option="next"]').removeAttribute('disabled')
            }
        }        
    }

    addons_handling(e){
        var addon_items = this.querySelectorAll('.variant_itemWrpr');
        if(addon_items.length > 0){
            addon_items.forEach(function(item){
                item.addEventListener('click', function(e){
                    this.classList.toggle('active');
                })
            });
        }
    }
    
}
customElements.define('help-me-choose', HelpMeChoose)